import * as React from 'react';

import {LinkedEntity} from 'shells/linked-entity/linked-entity';

import type {EventFragmentSparse} from 'nutshell-graphql-types';

import {TimelineBanner} from './timeline-banner';

type Props = {
    event: EventFragmentSparse;
};

export function TimelineBannerAccountContactFormerStatus(props: Props) {
    const {event} = props;

    const payload = event.payload;
    if (payload.__typename !== 'AccountContactFormerStatusChange') {
        return null;
    }

    const markedFormer = payload.formerStatusAction === 'MARKED_FORMER';
    const iconVariant = markedFormer ? 'person-deleted' : 'person-created';

    const action = (
        <span>
            {'marked '}
            <LinkedEntity
                type='contacts'
                useEntityColor={true}
                shouldClientRoute={true}
                name={payload.formerStatusContact.name}
                htmlUrl={payload.formerStatusContact.htmlUrl}
                allowWrap={true}
                displayInline={true}
            />
            {' as a ' + (markedFormer ? 'former' : 'current') + ' employee of '}
            <LinkedEntity
                type='accounts'
                useEntityColor={true}
                shouldClientRoute={true}
                name={payload.account.name}
                htmlUrl={payload.account.htmlUrl}
                allowWrap={true}
                displayInline={true}
            />
        </span>
    );

    return (
        <TimelineBanner
            id={event.id}
            iconVariant={iconVariant}
            timestamp={event.changeTime}
            actor={event.actor}
            action={action}
        />
    );
}
